var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("FinanceManage.international_editAgentBillNo"),
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { display: "flex" },
          attrs: {
            "label-position": "left",
            "label-width": "90px",
            model: _vm.billing
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.CounterPartyBillingNo") } },
            [
              _c("el-input", {
                model: {
                  value: _vm.paramBilling.counterPartyBillingNo,
                  callback: function($$v) {
                    _vm.$set(_vm.paramBilling, "counterPartyBillingNo", $$v)
                  },
                  expression: "paramBilling.counterPartyBillingNo"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveEventHander } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.closeHandler } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }